const IceBoxLiquidTypeList = () => import('Views/iceBoxLiquidType/iceBoxLiquidType-list');
const IceBoxLiquidTypeAddEdit = () => import('Views/iceBoxLiquidType/iceBoxLiquidType-addEdit');
const IceBoxLiquidTypeTimeAddEdit = () => import('Views/iceBoxLiquidType/iceBoxLiquidTypeTime-addEdit');
export default[
  { path: '/iceBoxLiquidType-list', component: IceBoxLiquidTypeList },
  { path: '/iceBoxLiquidType-add', component: IceBoxLiquidTypeAddEdit },
  { path: '/iceBoxLiquidType-edit/:id', component: IceBoxLiquidTypeAddEdit },
  { path: '/iceBoxLiquidTypeTime-add', component: IceBoxLiquidTypeTimeAddEdit },
  { path: '/iceBoxLiquidTypeTime-edit/:id', component: IceBoxLiquidTypeTimeAddEdit },
];



// WEBPACK FOOTER //
// ./src/router/iceBoxLiquidType.js